<script>
export default {
    props:['name','maxSteps','minSteps'],
    data() {
        return {
            step: 1,
            timer: 0,
            effect: 'slide',
            views: [
                { 
                    view: 'table',
                    param: 'tableParams',
                    anim: 'tableAnim',
                    step: 1
                },
                { 
                    view: 'columns',
                    param: 'columnsParams',
                    anim: 'columnsAnim',
                    step: 2
                },
                { 
                    view: 'list',
                    param: 'listParams',
                    anim: 'listAnim',
                    step: 3
                },
                { 
                    view: 'calendar',
                    param: 'calendarParams',
                    anim: 'calendarAnim',
                    step: 4
                },
                { 
                    view: 'gantt',
                    param: 'ganttParams',
                    anim: 'ganttAnim',
                    step: 5
                },
                { 
                    view: 'form',
                    param: 'formParams',
                    anim: 'formAnim',
                    step: 6
                },

            ],
            tableAnim: null,
            columnsAnim: null,
            listAnim: null,
            calendarAnim: null,
            ganttAnim: null,
            formAnim: null
        };
    },    
    mounted() {
        this.$eventHub.$on('startTimer', function (name) {
            if(this.name == name){
            }            
        }.bind(this));

        this.$eventHub.$on('stopTimer', function (name) {
            if(this.name == name){
            }            
        }.bind(this));
        
        this.views.forEach(element => {
            const view = element.view;
            const params = {
                container: document.getElementById(`view-animation-${view}`),
                renderer: 'svg',
                loop: true,
                autoplay: false,
                path: `img/new-homepage/views-animations/${view}.json`,
                maxLoops: 1,
                rendererSettings: {
                    progressiveLoad: true,
                }
            };
            this[element.anim] = lottie.loadAnimation(params);
            this[element.anim].addEventListener('loopComplete', this.tick);
        });
        if (this.step == 1) {
            this.tableAnim.play();
        }
    },
    methods:{
        goToStep(step, name)
        {
            if(this.name == name)
            {
                this.step = step;
            }
        },
        tick() 
        {        
            if(this.step == this.maxSteps){
                this.step = 1;                
            }else{
                this.step = this.step + 1;    
            }
        },
        tickDown() 
        {        
            if(this.step == this.minSteps){
                this.step = 6;                
            }else{
                this.step = this.step - 1;    
            }
        }
    },
    watch: {
        step() {
            this.views.forEach(element => {
                this[element.anim].stop();
                if (this.step == element.step) {
                    this[element.anim].play();
                }
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/ViewsSlider.vue